module.exports = __webpack_public_path__ + "img/1490199980.acbfdebe.jpg";